export const AvitoStyles = `
          [data-theme="avito-light"] {
            --color-D10: #F2F1F0;
            --color-B30: #CFEDFF;
            --color-B06: #CFEDFF;
            --color-O30: #FFECC9;
            --color-G30: #D2FCC4;

            --tag-active-borderColor: #000;
            --tag-active-bgColor: var(--color-D10);
            --menu-item-active-bgColor: #FFF;
            --tag-dark-borderColor: #FFF;
            --tag-dark-bgColor: var(--color-D10);
            --button-secondary-blue-hover-borderColor: var(--color-L100);
            --button-secondary-blue-hover-bgColor: var(--color-L100);
            --button-secondary-blue-borderColor: var(--color-L100);
            --button-secondary-blue-bgColor: var(--color-L100);
            --card-secondary-blue-bgColor: var(--color-B30);
            --alert-secondary-green-bgColor: var(--color-G30);
            --badge-secondary-dark-bgColor: var(--color-L100);

            [data-qa="Button"], [data-qa="form-submit"] {
              font-weight: 500;
              border-radius: 16px;
            }

            [data-qa="Alert"], [data-qa="Card"]{
              border-radius: 20px;
            }

            [data-qa="Card"]{
              [data-qa="OfferNote"]{
                color: var(--color-D100);
              }
            }

            [data-qa="Tag"]{
              border-radius: 12px;
              font-weight: 400;
              border-width: 2px;
            }

            [data-qa="OfferDetailsPopupBadges"]{
              --badge-secondary-dark-bgColor: var(--color-D10);
            }
          }
          `;
